import { lazy } from 'react';

export const UpdatePassword = lazy(() => import('./UpdatePassword.component'));
